import React, { useContext } from "react";
import { SimpleContext } from "../../../../../store/context/simple-context";
import { MODES, TARIFF_INFORMATION } from "../../content/index.content";
import SVG_SHOPPING_CART from "../../../../../assets/images/vector/components/Paywalls/Customizable/shopping-cart.svg";
import parse from "html-react-parser";
import { getTrueClasses } from "../../../../../helpers";
import { ExtensionController } from "../../../../../controllers/common/extensionController";
import TrackedLink from "../../../../Analytics/TrackedLink";
import Pay from "./Pay";
import SubTitle from "./SubTitle";
import Cheap from "./Cheap";
import "./index.scss";

const Tariff = () => {
  const {
    data: { options, optionsState, currentTariff, eventCategory },
    modes: { mode },
    translate: { t },
    update: { updateLink },
  } = useContext(SimpleContext);
  const isIframe = mode === MODES.iframe;
  const { title, tariff } = TARIFF_INFORMATION[currentTariff];

  const getNameVariantTariff = () => {
    let name = "base";
    const isPL = options.includes("PL") && optionsState.PL;
    const isR = options.includes("R") && optionsState.R;
    switch (true) {
      case isPL && isR:
        name = "PL_R";
        break;
      case isPL:
        name = "PL";
        break;
      case isR:
        name = "R";
        break;
    }
    return name;
  };

  const { pay, cheap, buyNowPath } = tariff[getNameVariantTariff()];
  return (
    <div className={getTrueClasses("GP-C-SB-T", `GP-C-SB-T_${currentTariff}`)}>
      <div className="GP-C-SB-T-TB">
        <div className="GP-C-SB-T-TB-SC">
          <img
            className="GP-C-SB-T-TB-SC__img"
            src={SVG_SHOPPING_CART}
            alt=""
          />
          <p className="GP-C-SB-T-TB-SC__text">{t("YOUR CART")}</p>
        </div>
        <div className="GP-C-SB-T-TB__wrap">
          <p className="GP-C-SB-T__title">{parse(t(title))}</p>
          <SubTitle />
        </div>
      </div>
      <div className="GP-C-SB-T-PB">
        <div className="GP-C-SB-T-PB__wrap">
          {pay && <Pay {...pay} />}
          {cheap && <Cheap cheap={cheap} />}
        </div>
        <TrackedLink
          handleClick={() =>
            isIframe
              ? ExtensionController.sendMessage({ event: "p.click" })
              : {}
          }
          classes="GP-C-SB-T__buyNow"
          category={eventCategory}
          action="Proceed to checkout"
          isChild={isIframe}
          path={updateLink(buyNowPath)}
        >
          {t("Proceed to checkout")}
        </TrackedLink>
        <p className="GP-C-SB-T__agree">
          {parse(t("10-day money-back guarantee"))}
        </p>
      </div>
    </div>
  );
};

export default Tariff;
